import DateField from 'components/form/RecurringForm/components/DatesRangeSelector/DateField/styled';

export default DateField;
